<template>
  <div
    class="upload-btn"
  >
    <label
      :class="`v-btn ${classes}${color} upload-btn`"
    >
    <input
      type="file"
      :name="name"
      :accept="accept"
      @change="onFileChange"
    />
      <span v-if="file">{{file.name}}</span>
      <span v-else>
        <v-icon dark>add</v-icon>
        {{title}}
      </span>
    </label>
  </div>
</template>

<script>
  import api from '@/utils/api'
  export default {
    name: 'upload-btn',
    props: {
      accept: {
        default: '*',
        type: String
      },
      block: {
        default: false,
        type: Boolean
      },
      fileChangedCallback: {
        default: undefined,
        type: Function
      },
      color: {
        default: 'primary',
        type: String
      },
      disabled: {
        default: false,
        type: Boolean
      },
      flat: {
        default: false,
        type: Boolean
      },
      hover: {
        default: true,
        type: Boolean
      },
      icon: {
        default: false,
        type: Boolean
      },
      large: {
        default: false,
        type: Boolean
      },
      loading: {
        default: false,
        type: Boolean
      },
      name: {
        default: 'uploadFile',
        type: String
      },
      outline: {
        default: false,
        type: Boolean
      },
      ripple: {
        default: true,
        type: Boolean
      },
      round: {
        default: false,
        type: Boolean
      },
      small: {
        default: false,
        type: Boolean
      },
      target: {
        type: String
      },
      action: {
        type: String,
        default: 'POST'
      },
      alias: {
        type: String,
        default: 'file'
      },
      title: {
        default: 'Prześlij plik',
        type: String
      }
    },
    data () {
      return {
        file: null
      }
    },
    computed: {
      classes () {
        const classes = {
          'v-btn--block': this.block,
          'v-btn--flat': this.flat,
          'upload-btn-hover': this.hover,
          'v-btn--icon': this.icon,
          'v-btn--large': this.large,
          'v-btn--loading': this.loading,
          'v-btn--outline': this.outline,
          'v-btn--round': this.round,
          'v-btn--small': this.small,
          'v-btn--disabled': this.disabled
        }
        let classString = ''
        for (let key in classes) {
          if (classes[key]) {
            classString += `${key} `
          }
        }
        return classString
      }
    },
    methods: {
      uploadProgress (oEvent) {
        if (oEvent.lengthComputable) {
          let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
          this.$emit('progress', percentComplete)
        } else {
          // Unable to compute progress information since the total size is unknown
          this.$emit('progress', false)
        }
      },
      onFileChange (e) {
        let files = e.target.files || e.dataTransfer.files

        if (!files.length) {
          return
        };

        this.file = files[0]
        let formData = new FormData()
        formData.append(this.alias, this.file)
        api({
          method: this.action,
          url: this.target,
          data: formData,
          onUploadProgress: this.uploadProgress
        }).then((data) => {
          this.$emit('finish', data)
        })
      }
    }
  }
</script>

<style scoped>
  .upload-btn {
    padding-right: 16px;
  }
  .upload-btn input[type=file] {
    position: absolute;
    height: 0.1px;
    width: 0.1px;
    overflow: hidden;
    opacity: 0;
    z-index: -1;
  }
  .upload-btn-hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/utils/FileUpload.vue